<template>
  <!-- <pub-side-bar class="crmaside" :key="numberKey" :hasStatus="hasStatus" :status="statusList" :userinfo="info" :trueStatus="status" @onStatus="onStatus" @onPubsidebarToggle="onPubsidebarToggle" /> -->
  <!-- <sider-menu
    :projectName="projectName"
    :key="numberKey"
    :projectTitle="projectTitle"
    :menus="siderMenus"
    :currentMenu="currentMenu"
    :collapsed="collapsed"
    :customJump="customJump"
    :_bubbleTip="showBubbleTips"
    :userConfigItem="userConfigItem"
  /> -->
  <SiderMenu
    :logo="getLogo"
    :key="numberKey"
    use-full-logo
    :hideOnCollapsed="true"
    :menus="siderMenus"
    :currentMenu="currentMenu"
    :collapsed="collapsed"
    :goHome="goHome"
    :beforeMenuChange="beforeMenuChange"
  />
</template>

<script>
import pkg from '../../../package.json'
import { mapState } from 'vuex'
import SiderMenu from './AsyncSider'
import { getNewWorkbenchWhitePath, oldWorkbenchWhitePaths } from '@/layout/container/const'
import { i18n } from '@/i18n/index.js'
import logo_light from '@/assets/images/logo_light.png'
import logo_light_mini from '@/assets/images/logo_light_mini.png'
import logo_dark from '@/assets/images/logo_dark.png'
import logo_dark_mini from '@/assets/images/logo_dark_mini.png'

export default {
  name: 'CrmAside',
  props: {
    info: {},
    hasStatus: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: null
    }
  },

  components: { SiderMenu },
  data() {
    return {
      projectTitle: i18n.t('crm.onlineCs.online.workbench'),
      projectName: 'im',
      trueStatus: 0,
      numberKey: 0,
      pubsidebarToggle: false,
      statusList: [
        { value: 1, label: `空闲`, message: 'free' },
        { value: 2, label: `离线`, message: 'leave' },
        { value: 3, label: `置忙`, message: 'busy' },
        { value: 4, label: `振铃`, message: 'ring' },
        { value: 5, label: `接线中`, message: 'doing' }
      ],
      getLogo: {
        logoLight: logo_light,
        logoDark: logo_dark,
        logoMinLight: logo_light_mini,
        logoMinDark: logo_dark_mini
      }
    }
  },
  computed: {
    ...mapState('app', ['siderMenus', 'currentMenu', 'jumpSwitchConfig']),
    ...mapState('Authentication', ['user']),
    inPages() {
      const pages = ['/callin', '/tr_callin', '/im']
      return pages.some(item => {
        return this.$route.path.indexOf(item) > -1
      })
    },
    isTr() {
      return this.$route.path.includes('/tr_callin')
    },
    // 是否工作台
    isWorkbench() {
      // const pathFlag =
      // (path?.match?.(/^(\/im|\/callin|\/tr_callin|\/crmcall)/) && !path?.match?.(/^(\/callin-workbench)/)) ||
      // (path?.startsWith('/callout') && callType == 9) // 排除商户工作台
      const path = this.$route.path || ''
      return path?.match?.(/^(\/im|\/callin|\/tr_callin|\/crmcall|\/simulate|\/callout)/)
    },
    showBubbleTips() {
      if (this.inPages) {
        let userConfig = window.localStorage.getItem(this.userConfigItem)
        try {
          userConfig = JSON.parse(userConfig)
          return userConfig.bubbleTip !== false
        } catch (error) {
          return true
        }
      }
      return false
    },
    collapsed() {
      if (this.inPages) {
        let userConfig = window.localStorage.getItem(this.userConfigItem)
        try {
          userConfig = JSON.parse(userConfig)
          return userConfig.collapsed
        } catch (error) {
          return false
        }
      }
      return false
    },
    userConfigItem() {
      return 'CRM_USER_CONFIG_h5newcallcenter' + this.user?.id
    }
  },
  mounted() {
    document.body.addEventListener('pubSiderBarInit', this.pubSiderBarInit, { once: true })
  },
  beforeDestroy() {
    document.body.removeEventListener('pubSiderBarInit', this.pubSiderBarInit, { once: true })
  },
  methods: {
    pubSiderBarInit() {
      console.log('force update pubSiderBar')
      this.numberKey++
    },
    //跳转首页
    goHome() {
      window.open(`//${window.location.host}/microweb-pc/#/mw-qmove-operation/home`, '_blank')
    },
    customJump(menu, menuPath) {
      try {
        if (!this.isWorkbench || !menu?.path) return false
        const targetPath = menu.path
        // 如果点击当前tab,走老的逻辑
        if (this.isTr && targetPath?.includes?.('/tr_callin')) return false // 当前菜单，则不跳转
        if (targetPath?.includes?.('http')) {
          window.open(targetPath, '_blank')
        } else {
          window.open(`//${window.location.host}${targetPath}`, '_blank')
        }
        return true
      } catch (e) {
        console.warn(e?.message)
        this.$libTrack?.trace?.('[菜单自定义跳转]： 处理错误，' + e?.message, menu)
        return false
      }
    },
    beforeMenuChange(menu, menuPath) {
      menu.path = getNewWorkbenchWhitePath(menu.path)
      try {
        // 如果开启新工作台调整配置
        if (oldWorkbenchWhitePaths.includes(menu?.path) && this.jumpSwitchConfig?.switch) {
          if (
            this.jumpSwitchConfig?.all ||
            this.jumpSwitchConfig?.departmentIds?.includes?.(this.user?.departmentId) ||
            this.jumpSwitchConfig?.userIds?.includes?.(this.user?.jobNumber)
          ) {
            console.log('跳转到新工作台调整配置')
            menu.path = getNewWorkbenchWhitePath(menu.path)
          }
        }
        if (!this.isWorkbench || !menu?.path) return true
        const targetPath = menu.path
        // 如果点击当前tab,走老的逻辑
        if (this.isTr && targetPath?.includes?.('/tr_callin')) return false // 当前菜单，则不跳转
        if (targetPath?.includes?.('http')) {
          window.open(targetPath, '_blank')
        } else {
          window.open(`//${window.location.host}${targetPath}`, '_blank')
        }
        return false
      } catch (e) {
        console.warn(e?.message)
        this.$libTrack?.trace?.('[菜单自定义跳转]： 处理错误，' + e?.message, menu)
        return true
      }
    },
    onPubsidebarToggle(toggle) {
      this.pubsidebarToggle = toggle
      this.$emit('toggle', toggle)
    },
    /** 切换状态*/
    onStatus(val) {
      // 振铃接线不能切换
      if (this.status > 3 || +this.status === val || +val > 3) return
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="stylus" scoped>
.pubsidebar
  height 100%
.pubsidebarToggle
  margin-left 94px

/deep/.pubsidebar-list .bottom_menu
  z-index 100
/deep/.toggle-wrapper
  box-sizing: content-box
/deep/.bill_tip
  z-index 2020
/deep/.pubsidebar-list .bottom_menu
  position relative
/deep/.pubsidebar-list.closed .menu ul li i em
  z-index 2020
/deep/.pubsidebar-list .menu ul .sub_menu_item .mouseHover2 .menu_item
  z-index 2020
</style>
